import axios from "axios";

const API = axios.create({
  baseURL: "https://firetracker-web-application-2.onrender.com"
});

export default API;

